import { Seo, businessSchema } from "@/components/Seo";
import { Intro } from "@/components/Intro";
import { Hero } from "@/components/home/Hero";
import { Focus } from "@/components/home/Focus";
import { Nikola } from "@/components/home/Nikola";
import { Fairness } from "@/components/home/Fairness";
import { CtaBand } from "@/components/home/CtaBand";

export default function Home() {
  return (
    <>
      <Intro />
      <Seo title="Autogarage Siebnen SZ – Wir verstehen Autos. Und Ihre Anliegen." description="NIVO Garage an der Zürcherstrasse 34 in Siebnen (SZ): Service, Reparaturen und Diagnose für Fahrzeuge aller Marken. Persönlich beraten, verständlich erklärt." schema={businessSchema} />
      <Hero />
      <Focus />
      <Nikola />
      <Fairness />
      <CtaBand />
    </>
  );
}
